"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PillColor = exports.PillSize = void 0;
var PillSize;
(function (PillSize) {
    PillSize["ExtraSmall"] = "ExtraSmall";
    PillSize["Small"] = "Small";
    PillSize["Medium"] = "Medium";
})(PillSize = exports.PillSize || (exports.PillSize = {}));
var PillColor;
(function (PillColor) {
    PillColor["Primary"] = "primary";
    PillColor["Secondary"] = "secondary";
    PillColor["Archive"] = "support40";
    PillColor["Success"] = "success";
    PillColor["alertStrong"] = "alert-strong";
    PillColor["Fail"] = "fail";
    PillColor["NotificationStrong"] = "notification-strong";
})(PillColor = exports.PillColor || (exports.PillColor = {}));
//# sourceMappingURL=Pill.types.js.map